module.exports = __webpack_public_path__ + "media/images/emblems/Massonnens-coat_of_arms-3c8ae915b4662a2c53abd7c616a7954b.svg";